import {
  userToken,
  userLogin,
  userLogout,
  userAuthValidation
} from '@/services/user'

const authentication = {
  namespaced: true,
  state: {
    firstValidation: false,
    loginMessage: null,
    token: null,
    user: { },
    status: {
      loggedIn: false,
      process: false
    }
  },
  actions: {
    login( { commit }, { username, password } ) {
      commit( 'loginProcess', true )
      return userLogin( username, password )
        .then( response => {
          const data = response.data

          if ( data.user && data.token ) {
            commit( 'loginSuccess', data.user, data.token )
          }

          return response;
        } ).catch( exception => {
          commit( 'loginFailure', exception.message )
          throw exception
        } );
    },
    logout( { commit }, message ) {
      userLogout().then( () => {
        return commit( 'logout', message )
      } ).catch( () => {
        return commit( 'logout', message )
      } )
    },
    setLoginMessage( { commit }, message ) {
      commit( 'setLoginMessage', message )
    },
    validation( { commit, state }, { token } ) {
      if ( !token ) {
        token = userToken()
      }

      return userAuthValidation( token )
        .then( response => {
          if ( false === state.firstValidation ) {
            commit( 'firstValidation', true )
          }

          const data = response.data
          if ( data.user ) {
            commit( 'loginSuccess', data.user )
          }

          return response
        } );
    },
    token( { commit }, { token } ) {
      return commit( 'setToken', token )
    }
  },
  mutations: {
    loginProcess( state, process ) {
      if ( true == process ) {
        state.status.process = true
      }
      else if ( false == process ) {
        state.status.process = false
      }
      else {
        state.status.process = false
      }

      return state.status.process
    },
    loginSuccess( state, user, token ) {
      state.firstValidation = false
      state.status.loggedIn = true
      state.status.process = false
      state.loginMessage = null
      state.user = user;
      state.token = token ? token : null
    },
    loginFailure( state, message ) {
      state.firstValidation = false
      state.status.loggedIn = false
      state.status.process = false
      state.loginMessage = ( message && message.length ) ? message : null
      state.user = {}
      state.token = null
    },
    logout( state, message ) {
      state.firstValidation = false
      state.status.loggedIn = false
      state.status.process = false
      state.loginMessage = ( message && message.length ) ? message : null
      state.user = {}
      state.token = null
    },
    setLoginMessage( state, message ) {
      state.loginMessage = message
    },
    setToken( state, token ) {
      if ( token ) {
        state.token = token
      }

      return state.token
    },
    firstValidation( state, ok ) {
      if ( true === ok || false === ok ) {
        state.firstValidation = ok
      }

      return state.firstValidation
    }
  }
};

export default authentication
